export var Marquee = function (options) {
    var count = options.count, // 跑马灯数量，比如8个，9个...
    minTime = options.minTime, // 最少次数，建议 count * 3
    target = options.target, // 目标值
    _a = options.initSpeed, // 目标值
    initSpeed = _a === void 0 ? 500 : _a, // 初始速度
    _b = options.miniSpeed, // 初始速度
    miniSpeed = _b === void 0 ? 100 : _b, // 最小速度
    _c = options.maxSpeed, // 最小速度
    maxSpeed = _c === void 0 ? 500 : _c, // 最大速度
    _d = options.metaSpeed, // 最大速度
    metaSpeed = _d === void 0 ? 100 : _d, // 加减速度量
    _e = options.startIndex, // 加减速度量
    startIndex = _e === void 0 ? 0 : _e, // 开始位置
    _f = options.before, // 开始位置
    before = _f === void 0 ? function () { } : _f, // 每次跑执行前
    _g = options.done // 完成，最终到达目标值
    , // 每次跑执行前
    done = _g === void 0 ? function () { } : _g // 完成，最终到达目标值
    ;
    // 跑马灯，最少跑多少次
    var min = (minTime || count * 3) + Math.round(count / 2);
    // 总共跑了多少次
    var runs = 0;
    var total = min + target + count - Math.round(count / 2);
    // 速度
    var speed = initSpeed;
    var minSpeed = miniSpeed;
    var maxiSpeed = maxSpeed;
    // 加减速度
    var speedVars = metaSpeed;
    // 开始跑的节点下标
    var index = startIndex;
    function run() {
        // 每次执行前
        var prev = index - 1;
        if (prev === -1) {
            prev = count - 1;
        }
        var current = index;
        before(prev, current);
        // 业务逻辑
        index += 1;
        if (index >= count) {
            index = 0;
        }
        // 处理加减速逻辑
        if (speed > minSpeed && runs < min) {
            speed -= speedVars;
        }
        else {
            if (speed < maxiSpeed && runs >= min) {
                speed += speedVars;
            }
        }
        // 设置跑马灯数量
        runs += 1;
        if (runs >= total) {
            done(index);
        }
        else {
            // 每次执行后
            setTimeout(function () {
                run();
            }, speed);
        }
    }
    // 运行
    run();
};
//# sourceMappingURL=functions.js.map